/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * cards
 */

const cards = {
    cfg:  {
        name: 'cards',
        filter: document.querySelector('.js-cards-filter'),
        indicator: document.querySelector('.js-cards-filterIndicator'),
        select: document.getElementById('js-cards-filterSelect'),
        triggers: document.querySelectorAll('.js-cards-filterTrigger'),
        subTriggers: document.querySelectorAll('.js-cards-filterTriggerSub'),
        items: [...document.querySelectorAll('.js-cards-filterItem')],
        subItems: [...document.querySelectorAll('.js-cards-filterSubItem')],
        initialValue: '0'
    },

    initFilter() {
        this.cfg.initialValue = this.cfg.filter.dataset.init;
        let i = 0;
        let index = 0;

        this.cfg.triggers.forEach((trigger) => {
            // let isData = false;
            const ids = trigger.dataset.sub.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.initialValue) {
                    isData = true;
                }
            });

            if (isData || trigger.dataset.id === this.cfg.initialValue) {
                index = i;
            }
            i += 1;
        });

        // const triggers = this.cfg.filter.querySelectorAll('.js-cards-filterTrigger');

        // Main Categories
        this.cfg.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.resetFilter();
                this.setFilter(event, false);
            });
        });

        // SubCategories
        this.cfg.subTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.resetFilter();
                this.setFilter(event, true);
            });
        });

        this.cfg.select.addEventListener('change', (event) => {
            this.resetFilter();
            this.setFilterSelect(event);
        });

        this.cfg.triggers[index].classList.add('is-selected');
        // eslint-disable-next-line
        this.cfg.indicator.setAttribute('style',`left:${this.cfg.triggers[index].offsetLeft}px; width:${this.cfg.triggers[index].clientWidth}px`);


        this.cfg.items.forEach((item) => {
            const ids = item.dataset.id.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.initialValue) {
                    isData = true;
                }
            });

            if (isData || this.cfg.initialValue === '*') {
                item.classList.add('is-selected');
            } else {
                item.classList.remove('is-selected');
            }
        });

        // Show / Hide SubItems
        this.cfg.subTriggers.forEach((item) => {
            if (this.cfg.triggers[index].dataset.id === item.dataset.parent) {
                item.parentNode.classList.add('is-visible');

                if (this.cfg.initialValue === item.dataset.id) {
                    item.parentNode.classList.add('is-selected');
                } else {
                    item.parentNode.classList.remove('is-selected');
                }
            } else {
                item.parentNode.classList.remove('is-visible');
            }
        });

        this.resizeAllGridItems();
    },

    setFilter(event, subcategory) {
        event.preventDefault();
        const target = event.currentTarget;

        if (subcategory) {
            // Select MainCategory
            this.cfg.triggers.forEach((trigger) => {
                if (trigger.dataset.id === target.dataset.parent) {
                    trigger.classList.add('is-selected');
                }
            });

            // Select SubCategory
            target.parentElement.classList.add('is-selected');
            // Show / Hide SubItems
            this.cfg.subTriggers.forEach((item) => {
                if (target.dataset.parent === item.dataset.parent) {
                    item.parentNode.classList.add('is-visible');

                    if (target.dataset.id === item.dataset.id) {
                        item.parentNode.classList.add('is-selected');
                    } else {
                        item.parentNode.classList.remove('is-selected');
                    }
                } else {
                    item.parentNode.classList.remove('is-visible');
                }
            });

            this.cfg.items.forEach((item) => {
                const ids = item.dataset.id.split(',');
                let isData = false;

                ids.forEach((val) => {
                    if (val === target.dataset.id) {
                        isData = true;
                    }
                });

                // eslint-disable-next-line
                if (isData || target.dataset.id === '*' && item.dataset.id.includes(target.dataset.parent)) { //
                    item.classList.add('is-selected');
                } else {
                    item.classList.remove('is-selected');
                }
            });
        } else {
            target.classList.add('is-selected');
            // eslint-disable-next-line
            this.cfg.indicator.setAttribute('style',`left:${target.offsetLeft}px; width:${target.clientWidth}px`);

            this.cfg.items.forEach((item) => {
                const ids = item.dataset.id.split(',');
                let isData = false;

                ids.forEach((val) => {
                    if (val === target.dataset.id) {
                        isData = true;
                    }
                });

                if (isData || target.dataset.id === '*') {
                    item.classList.add('is-selected');
                } else {
                    item.classList.remove('is-selected');
                }
            });

            // Show / Hide SubItems
            this.cfg.subTriggers.forEach((item) => {
                if (target.dataset.id === item.dataset.parent) {
                    item.parentNode.classList.add('is-visible');
                } else {
                    item.parentNode.classList.remove('is-visible');
                    item.parentNode.classList.remove('is-selected');
                }
            });
        }

        this.resizeAllGridItems();
    },

    setFilterSelect(event) {
        event.preventDefault();

        this.cfg.items.forEach((item) => {
            const ids = item.dataset.id.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.select.value) {
                    isData = true;
                }
            });

            if (isData || this.cfg.select.value === '*') {
                item.classList.add('is-selected');
            } else {
                item.classList.remove('is-selected');
            }
        });

        // this.resizeAllGridItems();
    },

    resetFilter() {
        this.cfg.triggers.forEach((trigger) => {
            trigger.classList.remove('is-selected');
        });

        // this.cfg.triggers[0].classList.add('is-selected');

        this.cfg.items.forEach((item) => {
            item.classList.add('is-selected');
        });
    },

    resizeGridItem(item) {
        const grid = document.getElementsByClassName('o-cards__itemWrapper')[0];
        // eslint-disable-next-line
        let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);
        // eslint-disable-next-line
        let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10);
        // eslint-disable-next-line
        let rowSpan = Math.ceil((item.querySelector('.m-card').clientHeight+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = `span ${rowSpan}`;
    },

    resizeAllGridItems() {
        this.cfg.items.forEach((item) => {
            this.resizeGridItem(item);
        });
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.filter) {
                this.resetFilter();
                this.initFilter();
                this.resizeAllGridItems();
            }
        });

        window.addEventListener('resize', () => {
            if (this.cfg.filter) {
                this.resizeAllGridItems();
            }
        });
    }
};

export default cards;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/cards/_script.js